/**
 * web/src/screens/Us/tabs.ts — Us's sub-navigation, declared once
 * (card 8hGV3kwDaVoB). The Us screen renders this row; Explore builds its Us
 * rows from the same array, so a tab added or removed here is a door added or
 * removed there, with no second list to keep in step.
 */
import type { SubTabDef } from '../../components/SubTabs';

/** Us's sub-navigation (card sjFxIbWi3UgN) — same row, same treatment as
 *  Notebook and Life. */
export const US_TABS: SubTabDef[] = [
  { key: 'questions', label: 'Questions' },
  { key: 'share', label: 'Share' },
  /* One door to every game (card 4WYL7EXoxlJo): Nocturne used to sit here as
     its own sibling tab, which is why nobody found it. It is a game, so it now
     opens from inside the Games screen. The key stays 'game' so every existing
     #us-tab-game selector and stored tab key still resolves. */
  { key: 'game', label: 'Games' },
  { key: 'dates', label: 'Dates' },
  { key: 'digest', label: 'Digest' },
];
